import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routes.enum'
import { ACTION_ROLES } from '@/utils/constants'
import { requireAuthenticatedUser } from '@/router/guards'

export const validatorRoutes: RouteRecordRaw[] = [
  {
    path: '/validators',
    name: ROUTES.VALIDATORS,
    component: () => import('@/modules/validators/views/ValidatorsIndex.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.VALIDATORS_VIEW }
  },
  {
    path: '/validators/:id',
    name: ROUTES.VALIDATOR_DETAILS,
    component: () => import('@/modules/validators/views/ValidatorDetails.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.VALIDATOR_DETAILS_VIEW }
  }
]
